import type { HTMLAttributes } from 'react';
import { TextDeco } from '@paypoteam/page-components';
import { P } from '@paypoteam/ui-components';

import { cn } from '@/lib/utils';

import type { NumberDataType } from '../DataInNumbersSection.types';

export interface NumberItemProps extends HTMLAttributes<HTMLDivElement> {
    itemData: NumberDataType;
}

export default function NumberItem({ itemData, className }: NumberItemProps) {
    return (
        <div
            className={cn(
                `flex w-[inherit] flex-col items-center pb-6 lg:w-1/3`,
                className,
            )}
        >
            <TextDeco>{itemData.data}</TextDeco>

            <P
                weight="bold"
                className="text-center text-md md:text-lg"
            >
                {itemData.description}
            </P>
        </div>
    );
}
